import { all, takeLatest } from 'redux-saga/effects';
import {
  FETCH_LIST,
  FETCH_CAT,
  FETCH_OVERLAY,
  FETCH_TEMPLATE,
} from 'store/Constants/List/ListTypes';
import fetchList, { fetchCats, renderOverlay, fetchTemplate } from './ListSaga';

export default function* ListWatcher() {
  yield all([
    takeLatest(FETCH_LIST, fetchList),
    takeLatest(FETCH_CAT, fetchCats),
    takeLatest(FETCH_OVERLAY, renderOverlay),
    takeLatest(FETCH_TEMPLATE, fetchTemplate),
  ]);
}
